
import { defineStore } from 'pinia'

export const useSnackbarStore = defineStore('snackbar', {
    state: () => ({
        show: false,
        color: 'success', // або 'error'
        text: '',
        timeout: 3000
    }),
    actions: {
        notify({ text, color = 'success', timeout = 3000 }) {
            this.text = text
            this.color = color
            this.timeout = timeout
            this.show = true
        },
        close() {
            this.show = false
        }
    }
})
